
export const PaginateLeft = (props : any) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.235 18.296a.96.96 0 0 1-.717-.293l-5.281-5.17a1.242 1.242 0 0 1-.286-.392 1.096 1.096 0 0 1-.088-.443c0-.162.03-.31.088-.444.059-.134.154-.264.286-.391l5.28-5.164a.96.96 0 0 1 .718-.293 1.04 1.04 0 0 1 .905.505.993.993 0 0 1 .143.528c0 .283-.113.534-.337.754l-4.636 4.505 4.636 4.504c.224.22.337.474.337.762a.98.98 0 0 1-.143.52c-.095.156-.222.28-.381.373-.159.093-.333.14-.524.14z" fill="#33C" fillRule="evenodd"/>
        </svg>
    );
}
